import React, { useEffect, useState } from 'react';
import { notification } from '../../hocs/notification';
import moment from 'moment';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import {
    FaHeading, FaPlus,
    FaUser,
    FaMapMarkerAlt,
    FaInfoCircle,
    FaSave,
    FaArrowLeft,
    FaEdit,
    FaCheckCircle,
    FaIdCardAlt,
} from 'react-icons/fa';
import { LuLandPlot } from "react-icons/lu";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Input,
    Label,
    InputGroup,
    InputGroupText,
    Spinner,
    Button,
    Alert,
    Progress,
    Modal,
    ModalHeader,
    ModalBody,

} from 'reactstrap';

const EditFarmer = ({ data, back }) => {
    
    const [loading, setLoading] = useState(false);
    const [landUpdateLoading, setLandUpdateLoading] = useState({}); // Track loading for individual land updates
    const [docUpdateLoading, setDocUpdateLoading] = useState({}); // Track loading for individual land updates
    const [hindiNameLoading, setHindiNameLoading] = useState(false);
    const [regNo, setRegNo] = useState('0');
    const [name, setName] = useState(data.f_name);
    const [nameHin, setNameHin] = useState(data.f_name_ne);
    const [spouseName, setSpouseName] = useState(data.f_spouse_name);
    const [spouseNameHin, setSpouseNameHin] = useState(data.f_spouse_name_ne);
    const [age, setAge] = useState(data.age);
    const [dob, setDob] = useState(data.dob);
    const [gender, setGender] = useState(data.gender);
    const [category, setCategory] = useState(data.category);
    const [mobileNo, setMobileNo] = useState(data.mobile_no);
    const [altMobileNo, setAltMobileNo] = useState(data.mobile_no_2);

    const [state, setState] = useState(data.state_id);
    const [stateOpt, setStateOpt] = useState(data.state_name);
    const [district, setDistrict] = useState(data.dist_id);
    const [districtOpt, setDistrictOpt] = useState(data.district_name);
    const [block, setBlock] = useState(data.block_id);
    const [blockOpt, setBlockOpt] = useState(data.block_name);
    const [village, setVillage] = useState(data.vill_id);
    const [villageOpt, setVillageOpt] = useState(data.village_name);
    const [address, setAddress] = useState(data.f_address);

    // Land details state
    const [landDetals, setLandDetals] = useState([]);
    const [editableLandData, setEditableLandData] = useState({});
    const [addLandData, setAddLandData] = useState({
        plot_no: '',
        holding_no: '',
        holding_area: '',
        holding_type_id: '0',
        mouza_no: '',
        jl_no: '',
        khatiyan: '',
        ownership: '',
        latitude: '',
        longitude: '',
    });
    const [addLandModal, setAddLandModal] = useState(false);
    // Document details state
    const [addDocumentModal, setAddDocumentModal] = useState(false);
    const [documentDetals, setDocumentDetals] = useState([]);
    const [addDocumentData, setAddDocumentData] = useState({
        doc_type_id: '',
        doc_no: '',
    });
    const [editableDocumentData, setEditableDocumentData] = useState({});

    // Form completion progress
    const [formProgress, setFormProgress] = useState(0);

    useEffect(() => {
        get_land_dtl();
        get_document_dtl();
        get_state_list();
        get_dist_list({ target: { "value": data.state_id } });
        get_block_list({ target: { "value": data.dist_id } });
        get_village_list({ target: { "value": data.block_id } });
        calculateProgress();
    }, []);

    useEffect(() => {
        calculateProgress();
    }, [name, gender, category, state, district, block, village, mobileNo]);

    const calculateProgress = () => {
        const requiredFields = [name, gender, category, state, district, block, village, mobileNo];
        const filledFields = requiredFields.filter(field => field && field !== '0').length;
        const progress = Math.round((filledFields / requiredFields.length) * 100);
        setFormProgress(progress);
    };

    const get_document_dtl = () => {
        let postData = [{ "org_id": Number(sessionStorage.getItem('org_id')), "user_id": Number(sessionStorage.getItem('user_id')), "farmer_code": Number(data.farmer_code) }];
        axios({
            method: 'post',
            url: mainurl + 'Farmer/farmer_document_view',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (!response.data || response.data.length === 0) {

                } else {

                    setDocumentDetals(response.data);
                    // Initialize editable land data
                    const editableData = {};
                    response.data.forEach((doc, index) => {
                        editableData[index] = {
                            f_doc_id: doc.f_doc_id,
                            doc_type_id: doc.doc_type_id,
                            doc_no: doc.doc_no || '',

                        };
                    });
                    setEditableDocumentData(editableData);
                }
            })
            .catch(error => {
                console.error('Error fetching document details:', error);
                let notify = notification({
                    message: "Failed to fetch document details",
                    type: 'error',
                });
                notify();
            });
    };

    // Update individual document field
    const updateDocumentField = (index, field, value) => {
        setEditableDocumentData(prev => ({
            ...prev,
            [index]: {
                ...prev[index],
                [field]: value
            }
        }));
    };

    // Update specific document record
    // Update specific land record
    const update_document_dtl = (index) => {
        const documentData = editableDocumentData[index];

        // Validation
        if (!documentData.doc_type_id) {
            let notify = notification({
                message: "Document Type is required",
                type: 'warn',
            });
            notify();
            return;
        }

        if (!documentData.doc_no.trim()) {
            let notify = notification({
                message: "Valid Document number is required",
                type: 'warn',
            });
            notify();
            return;
        }

        let postData = [
            {
                "org_id": Number(sessionStorage.getItem('org_id')),
                "user_id": Number(sessionStorage.getItem('user_id')),
                "farmer_code": Number(data.farmer_code),
                "f_doc_id": Number(documentData.f_doc_id),
                "doc_type_id": documentData.doc_type_id,
                "doc_no": documentData.doc_no,
                "created_date": moment().format("YYYY-MM-DD")
            }
        ];

        axios({
            method: 'post',
            url: mainurl + 'Farmer/update_farmer_document',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data && response.data.length > 0) {
                    let notify = notification({
                        message: `Document details updated successfully.`,
                        type: 'success'
                    });
                    notify();

                    // Refresh land details
                    get_document_dtl();
                } else {
                    let notify = notification({
                        message: "Update failed! Please try again",
                        type: 'error',
                    });
                    notify();
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Document update error:', error);
                let notify = notification({
                    message: "Update failed! Please check your connection and try again",
                    type: 'error',
                });
                notify();
            })
            .finally(() => {
                setDocUpdateLoading(prev => ({ ...prev, [index]: false }));
            });
    };

    const add_document_dtl = (e) => {
        e.preventDefault();
        setLoading(true);
        const postData = [{
            "org_id": Number(sessionStorage.getItem('org_id')),
            "user_id": Number(sessionStorage.getItem('user_id')),
            "farmer_code": Number(data.farmer_code),
            "doc_type_id": addDocumentData.doc_type_id,
            "doc_no": addDocumentData.doc_no,
            "created_date": moment().format("YYYY-MM-DD"),
        }];

        axios({
            method: 'post',
            url: mainurl + 'Farmer/add_farmer_document',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                setLoading(true);
                setAddDocumentModal(false);
                if (response.data && response.data.length > 0) {
                    let notify = notification({
                        message: `Document details added successfully.`,
                        type: 'success'
                    });
                    notify();

                    // Refresh land details
                    get_document_dtl();
                } else {
                    let notify = notification({
                        message: "Add failed! Please try again",
                        type: 'error',
                    });
                    notify();
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Document add error:', error);
                let notify = notification({
                    message: "Add failed! Please check your connection and try again",
                    type: 'error',
                });
                notify();
            });
    }

    const get_land_dtl = () => {
        let postData = [{ "org_id": Number(sessionStorage.getItem('org_id')), "user_id": Number(sessionStorage.getItem('user_id')), "farmer_code": Number(data.farmer_code) }];
        axios({
            method: 'post',
            url: mainurl + 'Farmer/view_farmer_land',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (!response.data || response.data.length === 0) {

                } else {

                    setLandDetals(response.data);
                    // Initialize editable land data
                    const editableData = {};
                    response.data.forEach((land, index) => {
                        editableData[index] = {
                            f_plot_id: land.f_plot_id,
                            f_plot_no: land.f_plot_no || '',
                            plot_no: land.plot_no || '',
                            holding_no: land.holding_no || '',
                            holding_area: land.holding_area || '',
                            holding_type_id: land.holding_type_id || '0',
                            mouza_no: land.mouza_no || '',
                            jl_no: land.jl_no || '',
                            khatiyan: land.khatiyan || '',
                            ownership: land.ownership || 1,
                            latitude: land.latitude || '',
                            longitude: land.longitude || ''
                        };
                    });
                    setEditableLandData(editableData);
                }
            })
            .catch(error => {
                console.error('Error fetching land details:', error);
                let notify = notification({
                    message: "Failed to fetch land details",
                    type: 'error',
                });
                notify();
            });
    };

    // Update individual land field
    const updateLandField = (index, field, value) => {
        setEditableLandData(prev => ({
            ...prev,
            [index]: {
                ...prev[index],
                [field]: value
            }
        }));
    };

    // Update specific land record
    const update_land_dtl = (index) => {
        const landData = editableLandData[index];

        // Validation
        if (!landData.plot_no.trim()) {
            let notify = notification({
                message: "Plot number is required",
                type: 'warn',
            });
            notify();
            return;
        }

        if (!landData.holding_area || landData.holding_area <= 0) {
            let notify = notification({
                message: "Valid holding area is required",
                type: 'warn',
            });
            notify();
            return;
        }

        if (landData.holding_type_id === '0') {
            let notify = notification({
                message: "Please select area type",
                type: 'warn',
            });
            notify();
            return;
        }

        setLandUpdateLoading(prev => ({ ...prev, [index]: true }));

        let postData = [
            {
                "org_id": Number(sessionStorage.getItem('org_id')),
                "user_id": Number(sessionStorage.getItem('user_id')),
                "farmer_code": Number(data.farmer_code),
                "f_plot_id": Number(landData.f_plot_id),
                "f_plot_no": Number(landData.f_plot_no),
                "plot_no": Number(landData.plot_no),
                "holding_no": landData.holding_no.trim(),
                "holding_area": Number(landData.holding_area),
                "holding_type_id": Number(landData.holding_type_id),
                "mouza_no": landData.mouza_no.trim(),
                "jl_no": landData.jl_no.trim(),
                "khatiyan": landData.khatiyan.trim(),
                "ownership": Number(landData.ownership),
                "latitude": landData.latitude || "0",
                "longitude": landData.longitude || "0",
                "reg_date": moment().format("YYYY-MM-DD")
            }
        ];

        axios({
            method: 'post',
            url: mainurl + 'Farmer/update_farmer_land',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data && response.data.length > 0) {
                    let notify = notification({
                        message: `Land details updated successfully for Plot ${landData.plot_no}`,
                        type: 'success'
                    });
                    notify();

                    // Refresh land details
                    get_land_dtl();
                } else {
                    let notify = notification({
                        message: "Update failed! Please try again",
                        type: 'error',
                    });
                    notify();
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Land update error:', error);
                let notify = notification({
                    message: "Update failed! Please check your connection and try again",
                    type: 'error',
                });
                notify();
            })
            .finally(() => {
                setLandUpdateLoading(prev => ({ ...prev, [index]: false }));
            });
    };

    const add_land_dtl = (e) => {
        e.preventDefault();
        setLoading(true);
        const postData = [{
            "org_id": Number(sessionStorage.getItem('org_id')),
            "user_id": Number(sessionStorage.getItem('user_id')),
            "farmer_code": Number(data.farmer_code),
            "f_plot_no": 0,
            "holding_no": addLandData.holding_no.trim(),
            "holding_area": addLandData.holding_area ? Number(addLandData.holding_area) : 0,
            "holding_type_id": addLandData.holding_type_id,
            "mouza_no": addLandData.mouza_no.trim(),
            "jl_no": addLandData.jl_no.trim(),
            "khatiyan":  addLandData.khatiyan.trim(),
            "plot_no": addLandData.plot_no ? Number(addLandData.plot_no) : 0,
            "ownership": addLandData.ownership ? Number(addLandData.ownership) : 1,
            "latitude": addLandData.latitude ? addLandData.latitude : "0",
            "longitude": addLandData.longitude ? addLandData.longitude : "0",
            "reg_date": moment().format("YYYY-MM-DD"),
        }]

        axios({
            method: 'post',
            url: mainurl + 'Farmer/add_farmer_land',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                setLoading(false);
                setAddLandModal(false);
                if (response.data && response.data.length > 0) {
                    let notify = notification({
                        message: `Land details add successfully.`,
                        type: 'success'
                    });
                    notify();

                    // Refresh land details
                    get_land_dtl();
                    
                } else {
                    let notify = notification({
                        message: "Add failed! Please try again",
                        type: 'error',
                    });
                    notify();
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Land add error:', error);
                setLoading(false);
                let notify = notification({
                    message: "Add failed! Please check your connection and try again",
                    type: 'error',
                });
                notify();
            })
    }

    const get_state_list = (e) => {
        let postData = [{ "country_code": "1" }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.state_code}> {row.state_name}</option>
                    )
                });

                setStateOpt(list);

            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_dist_list = (e) => {
        setState(e.target.value);
        let postData = [{ "state_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.district_code}> {row.district_name}</option>
                    )
                });

                setDistrictOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_block_list = (e) => {
        setDistrict(e.target.value);
        let postData = [{ "dist_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.block_code}> {row.block_name}</option>
                    )
                });

                setBlockOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_village_list = (e) => {
        setBlock(e.target.value);

        let postData = [{ "block_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_village_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.village_code}> {row.village_name}</option>
                    )
                });

                setVillageOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const update_handler = (e) => {
        e.preventDefault();
        setLoading(true);

        let flag = true;

        if (gender === "0") {
            flag = false;
            let notify = notification({ message: "Please select gender.", type: 'warn' });
            notify();
        }
        if (category === "0") {
            flag = false;
            let notify = notification({ message: "Please select category.", type: 'warn' });
            notify();
        }
        if (state === "0") {
            flag = false;
            let notify = notification({ message: "Please select state.", type: 'warn' });
            notify();
        }
        if (district === "0") {
            flag = false;
            let notify = notification({ message: "Please select district.", type: 'warn' });
            notify();
        }
        if (block === "0") {
            flag = false;
            let notify = notification({ message: "Please select block.", type: 'warn' });
            notify();
        }
        if (village === "0") {
            flag = false;
            let notify = notification({ message: "Please select village.", type: 'warn' });
            notify();
        }

        if (flag) {
            let postData = [{
                "org_id": Number(sessionStorage.getItem('org_id')),
                "user_id": Number(sessionStorage.getItem('user_id')),
                "f_reg_no": Number(regNo),
                "f_name": name.trim(),
                "f_name_ne": nameHin.trim(),
                "age": Number(age) || 0,
                "dob": dob,
                "mobile_no": mobileNo ? mobileNo : "0",
                "mobile_no_2": altMobileNo ? altMobileNo : "0",
                "gender": Number(gender) || 0,
                "Category": Number(category) || 0,
                "f_spouse_name": spouseName.trim(),
                "f_spouse_name_ne": spouseNameHin.trim(),
                "shareholder": 1,
                "state_id": Number(state),
                "dist_id": Number(district),
                "block_id": Number(block),
                "pan_id": "0",
                "vill_id": Number(village),
                "f_address": address,
                "farmer_code": Number(data.farmer_code),
                "photo": "",
                "reg_date": moment().format("YYYY-MM-DD"),
            }];

            axios({
                method: 'post',
                url: mainurl + 'Farmer/box_farmer_update',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            })
                .then(function (response) {
                    if (response.data[0].retcode === "101") {
                        let notify = notification({
                            message: `Farmer updated Successfully.`,
                            type: 'success'
                        });
                        notify();
                        back();
                    }
                })
                .catch(error => {
                    let notify = notification({
                        message: "Update failed! Try Again",
                        type: 'error',
                    });
                    notify();
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }

    const translate_text_handler = () => {
        // Translation logic here
    }

    return (
        <>
            {/* Header with Progress */}
            <Card className="mb-3 border-0 shadow-sm">
                <CardHeader className="bg-warning text-white">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <FaEdit size={20} />
                            <div>
                                <h5 className="mb-0">Edit Farmer Details</h5>
                                <small>Update farmer information and ensure all required fields are completed</small>
                            </div>
                        </div>
                        <div className="text-end">
                            <div className="mb-1">Form Completion</div>
                            <div className="d-flex align-items-center gap-2">
                                <Progress
                                    value={formProgress}
                                    color={formProgress === 100 ? "success" : "info"}
                                    style={{ width: '100px', height: '8px' }}
                                />
                                <span className="fw-bold">{formProgress}%</span>
                                {formProgress === 100 && <FaCheckCircle className="text-success" size={16} />}
                            </div>
                        </div>
                    </div>
                </CardHeader>
            </Card>

            {/* Success Alert for Pre-filled Data */}
            <Alert color="info" className="mb-4 border-0 shadow-sm">
                <FaInfoCircle className="me-2" />
                <strong>Editing Mode:</strong> Form is pre-filled with existing farmer data. Make necessary changes and click update.
            </Alert>

            <Form onSubmit={update_handler}>
                {/* Basic Information */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaUser className="text-primary" size={20} />
                            <h6 className="mb-0 text-primary">Basic Information</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Registration Number <small className="text-muted">(Optional)</small></Label>
                                    <Input
                                        type='text'
                                        value={regNo}
                                        onChange={(e) => setRegNo(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Enter registration number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Full Name <span className="text-danger">*</span></Label>
                                    <Input
                                        type='text'
                                        onKeyPress={(e) => !/^[a-zA-Z\s]*$/.test(e.key) && e.preventDefault()}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                        className="form-control-sm"
                                        placeholder="Enter farmer's full name"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Name (Regional Language) <span className="text-danger">*</span></Label>
                                    <InputGroup size="sm">
                                        <Input
                                            type='text'
                                            value={nameHin}
                                            onChange={(e) => setNameHin(e.target.value)}
                                            required
                                            placeholder="Enter name in regional language"
                                        />
                                        <InputGroupText
                                            className='bg-primary text-white cursor-pointer'
                                            onClick={!hindiNameLoading ? translate_text_handler : undefined}
                                        >
                                            {hindiNameLoading ?
                                                <Spinner size="sm" /> :
                                                <FaHeading />
                                            }
                                        </InputGroupText>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Spouse Name <span className="text-danger">*</span></Label>
                                    <Input
                                        type='text'
                                        onKeyPress={(e) => !/^[a-zA-Z\s]*$/.test(e.key) && e.preventDefault()}
                                        value={spouseName}
                                        onChange={(e) => setSpouseName(e.target.value)}
                                        required
                                        className="form-control-sm"
                                        placeholder="Enter spouse name"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Spouse Name (Regional Language) <span className="text-danger">*</span></Label>
                                    <InputGroup size="sm">
                                        <Input
                                            type='text'
                                            value={spouseNameHin}
                                            onChange={(e) => setSpouseNameHin(e.target.value)}
                                            required
                                            placeholder="Enter spouse name in regional language"
                                        />
                                        <InputGroupText
                                            className='bg-primary text-white cursor-pointer'
                                            onClick={!hindiNameLoading ? translate_text_handler : undefined}
                                        >
                                            {hindiNameLoading ?
                                                <Spinner size="sm" /> :
                                                <FaHeading />
                                            }
                                        </InputGroupText>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Age <span className="text-danger">*</span></Label>
                                    <Input
                                        type='text'
                                        maxLength={3}
                                        pattern="[0-9]*"
                                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                        value={age}
                                        onChange={(e) => setAge(e.target.value)}
                                        required
                                        className="form-control-sm"
                                        placeholder="Age"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Date of Birth</Label>
                                    <Input
                                        type='date'
                                        value={dob}
                                        onChange={(e) => setDob(e.target.value)}
                                        className="form-control-sm"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Gender <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={gender}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Gender--</option>
                                        <option value="1">Male</option>
                                        <option value="2">Female</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Category <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={category}
                                        onChange={(e) => setCategory(e.target.value)}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Category--</option>
                                        <option value="1">General</option>
                                        <option value="2">OBC</option>
                                        <option value="3">ST</option>
                                        <option value="4">SC</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Mobile Number <span className="text-danger">*</span></Label>
                                    <Input
                                        type='text'
                                        maxLength={10}
                                        pattern="[0-9]*"
                                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                        value={mobileNo}
                                        onChange={(e) => setMobileNo(e.target.value)}
                                        required
                                        className="form-control-sm"
                                        placeholder="Primary mobile number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Alternate Mobile Number</Label>
                                    <Input
                                        type='text'
                                        maxLength={10}
                                        pattern="[0-9]*"
                                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                        value={altMobileNo}
                                        onChange={(e) => setAltMobileNo(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Alternate mobile number"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Geographical Information */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaMapMarkerAlt className="text-success" size={20} />
                            <h6 className="mb-0 text-success">Geographical Information</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">State <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={state}
                                        onChange={get_dist_list}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select State--</option>
                                        {stateOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">District <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={district}
                                        onChange={get_block_list}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select District--</option>
                                        {districtOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Block <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={block}
                                        onChange={get_village_list}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Block--</option>
                                        {blockOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Village <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        value={village}
                                        onChange={(e) => setVillage(e.target.value)}
                                        required
                                        className="form-control-sm"
                                    >
                                        <option value="0">--Select Village--</option>
                                        {villageOpt}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-3">
                                    <Label className="fw-medium">Address</Label>
                                    <Input
                                        type='textarea'
                                        rows={2}
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="form-control-sm"
                                        placeholder="Enter detailed address"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                {/* Identity Details */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                                <FaIdCardAlt className="text-secondary" size={20} />
                                <h6 className="mb-0 text-secondary">Document Details</h6>
                            </div>

                            <Button
                                color="primary"
                                size="sm"
                                className="text-white"
                                onClick={() => setAddDocumentModal(true)}
                            > Add Document</Button>

                        </div>
                    </CardHeader>
                    <CardBody>

                        {documentDetals.length > 0 ? (
                            documentDetals.map((doc, index) => (
                                <div key={index} className="mb-4 p-3 border rounded bg-light">
                                    <h6 className="text-primary mb-3">Document Record #{index + 1}</h6>
                                    <Row className="mb-3">

                                        <Col md={3}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Document Type</Label>
                                                <Input
                                                    type="select"
                                                    value={editableDocumentData[index]?.doc_type_id || '1'}
                                                    onChange={(e) => updateDocumentField(index, 'doc_type_id', e.target.value)}
                                                    className="form-control-md"
                                                >
                                                    <option value="1">PAN</option>
                                                    <option value="2">EPIC</option>
                                                    <option value="3">UID</option>
                                                    <option value="4">Mandi Card</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Document Number</Label>
                                                <Input
                                                    type="text"
                                                    value={editableDocumentData[index]?.doc_no || ''}
                                                    onChange={(e) => updateDocumentField(index, 'doc_no', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Document No."
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2} className="">
                                            <Button
                                                color="warning"
                                                size="sm"
                                                className="text-white d-flex align-items-center gap-2 w-100 mt-4"
                                                onClick={() => update_document_dtl(index)}
                                                disabled={docUpdateLoading[index]}
                                            >
                                                {docUpdateLoading[index] ? (
                                                    <Spinner size="sm" />
                                                ) : (
                                                    <FaSave />
                                                )}
                                                {docUpdateLoading[index] ? 'Updating...' : 'Update'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            ))
                        ) : (
                            <Row>
                                <Col md={12} className="text-center">
                                    <Alert color="info" className="border-0">
                                        <FaInfoCircle className="me-2" />
                                        No Document details available for this farmer. Add Document details through the farmer registration process.
                                    </Alert>
                                </Col>
                            </Row>
                        )}


                    </CardBody>
                </Card>

                {/* Land Details */}
                <Card className="mb-4 border-0 shadow-sm">
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                                <LuLandPlot className="text-secondary" size={20} />
                                <h6 className="mb-0 text-secondary">Land Area Details</h6>
                            </div>

                            <Button
                                color="primary"
                                size="sm"
                                className="text-white"
                                onClick={() => setAddLandModal(true)}
                            > Add Land</Button>

                        </div>
                    </CardHeader>
                    <CardBody>
                        {landDetals.length > 0 ? (
                            landDetals.map((land, index) => (
                                <div key={index} className="mb-4 p-3 border rounded bg-light">
                                    <h6 className="text-primary mb-3">Land Record #{index + 1}</h6>
                                    <Row className="mb-3">
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Plot No. <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="text"
                                                    value={editableLandData[index]?.plot_no || ''}
                                                    onChange={(e) => updateLandField(index, 'plot_no', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Plot number"
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Holding No.</Label>
                                                <Input
                                                    type="text"
                                                    value={editableLandData[index]?.holding_no || ''}
                                                    onChange={(e) => updateLandField(index, 'holding_no', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Holding number"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Area (Acres) <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    value={editableLandData[index]?.holding_area || ''}
                                                    onChange={(e) => updateLandField(index, 'holding_area', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Area in acres"
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Area Type <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="select"
                                                    value={editableLandData[index]?.holding_type_id || '0'}
                                                    onChange={(e) => updateLandField(index, 'holding_type_id', e.target.value)}
                                                    className="form-control-sm"
                                                    required
                                                >
                                                    <option value="0">--Select Area Type--</option>
                                                    <option value="1">Don</option>
                                                    <option value="2">Baid</option>
                                                    <option value="3">Tanr</option>
                                                    <option value="4">Kanali</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Ownership</Label>
                                                <Input
                                                    type="select"
                                                    value={editableLandData[index]?.ownership || '1'}
                                                    onChange={(e) => updateLandField(index, 'ownership', e.target.value)}
                                                    className="form-control-sm"
                                                >
                                                    <option value="1">Owner</option>
                                                    <option value="2">Tenant</option>
                                                    <option value="3">Sharecropper</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Mouza No.</Label>
                                                <Input
                                                    type="text"
                                                    value={editableLandData[index]?.mouza_no || ''}
                                                    onChange={(e) => updateLandField(index, 'mouza_no', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Mouza number"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">JL No.</Label>
                                                <Input
                                                    type="text"
                                                    value={editableLandData[index]?.jl_no || ''}
                                                    onChange={(e) => updateLandField(index, 'jl_no', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="JL number"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Khatiyan</Label>
                                                <Input
                                                    type="text"
                                                    value={editableLandData[index]?.khatiyan || ''}
                                                    onChange={(e) => updateLandField(index, 'khatiyan', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Khatiyan"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Latitude</Label>
                                                <Input
                                                    type="text"
                                                    value={editableLandData[index]?.latitude || ''}
                                                    onChange={(e) => updateLandField(index, 'latitude', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Latitude"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup className="mb-2">
                                                <Label className="fw-medium">Longitude</Label>
                                                <Input
                                                    type="text"
                                                    value={editableLandData[index]?.longitude || ''}
                                                    onChange={(e) => updateLandField(index, 'longitude', e.target.value)}
                                                    className="form-control-md"
                                                    placeholder="Longitude"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2} className="">
                                            <Button
                                                color="warning"
                                                size="sm"
                                                className="text-white d-flex align-items-center gap-2 w-100 mt-4"
                                                onClick={() => update_land_dtl(index)}
                                                disabled={landUpdateLoading[index]}
                                            >
                                                {landUpdateLoading[index] ? (
                                                    <Spinner size="sm" />
                                                ) : (
                                                    <FaSave />
                                                )}
                                                {landUpdateLoading[index] ? 'Updating...' : 'Update'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            ))
                        ) : (
                            <Row>
                                <Col md={12} className="text-center">
                                    <Alert color="info" className="border-0">
                                        <FaInfoCircle className="me-2" />
                                        No land details available for this farmer. Add land details through the farmer registration process.
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                    </CardBody>
                </Card>

                {/* Submit Actions */}
                <Card className="border-0 shadow-sm">
                    <CardBody>
                        <Row>
                            <Col md={12} className="text-center">
                                <div className="d-flex gap-3 justify-content-center mb-3">
                                    <div className="mb-1">Form Completion</div>
                                    <div className="d-flex align-items-center gap-2">
                                        <Progress
                                            value={formProgress}
                                            color={formProgress === 100 ? "success" : "warning"}
                                            style={{ width: '300px', height: '8px' }}
                                        />
                                        <span className="fw-bold">{formProgress}%</span>
                                        {formProgress === 100 && <FaCheckCircle className="text-success" size={16} />}
                                    </div>
                                </div>
                                <div className="d-flex gap-3 justify-content-center">
                                    <Button
                                        color="warning"
                                        size="lg"
                                        type="submit"
                                        disabled={loading || formProgress < 100}
                                        className="d-flex align-items-center gap-2 px-4 text-white"
                                    >
                                        {loading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <FaSave />
                                        )}
                                        {loading ? 'Updating...' : 'Update Farmer Details'}
                                    </Button>
                                    <Button
                                        color="secondary"
                                        size="lg"
                                        onClick={back}
                                        disabled={loading}
                                        className="d-flex align-items-center gap-2 px-4 text-white"
                                    >
                                        <FaArrowLeft />
                                        Back to List
                                    </Button>
                                </div>
                                {formProgress < 100 && (
                                    <small className="text-warning mt-2 d-block">
                                        <FaInfoCircle className="me-1" />
                                        Please complete all required fields to update the farmer details
                                    </small>
                                )}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Form>
            {/* Add Document Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={addDocumentModal}
                toggle={() => setAddDocumentModal(!addDocumentModal)}
                className="modal-dialog-scrollable"
            >
                <ModalHeader
                    toggle={() => setAddDocumentModal(!addDocumentModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaIdCardAlt className="text-primary" />
                        <div>
                            <h5 className="mb-0">Add Document</h5>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={add_document_dtl}>
                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Document Type</Label>
                                    <Input
                                        type="select"
                                        onChange={(e) =>
                                            setAddDocumentData(prev => ({
                                                ...prev,
                                                doc_type_id: e.target.value
                                            }))
                                        }
                                        className="form-control-sm"
                                        required
                                    >
                                        <option value="">--Select Type--</option>
                                        <option value="1">PAN</option>
                                        <option value="2">EPIC</option>
                                        <option value="3">UID</option>
                                        <option value="4">Mandi Card</option>
                                    </Input>
                                </FormGroup>
                            </Col>

                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Document Number</Label>
                                    <Input
                                        type="text"
                                        onChange={(e) =>
                                            setAddDocumentData(prev => ({
                                                ...prev,
                                                doc_no: e.target.value
                                            }))
                                        }
                                        className="form-control-md"
                                        placeholder="Document No."
                                        required
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={4} className="">
                                <Button
                                    color="primary"
                                    size="sm"
                                    className="text-white align-items-center gap-2 w-100 mt-4"
                                    type="submit"
                                    disabled= {loading}
                                >
                                    {loading ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <FaPlus className='me-1' />
                                    )}
                                    {loading ? 'Adding...' : 'Add Document'}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>

            {/* Add Land Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={addLandModal}
                toggle={() => setAddLandModal(!addLandModal)}
                className="modal-dialog-scrollable"
            >
                <ModalHeader
                    toggle={() => setAddLandModal(!addLandModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaIdCardAlt className="text-primary" />
                        <div>
                            <h5 className="mb-0">Add New Land</h5>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={add_land_dtl}>
                        <Row>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Plot No. <span className="text-danger">*</span></Label>
                                    <Input
                                        type="text"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            plot_no: e.target.value
                                        }))}
                                        className="form-control-md"
                                        placeholder="Plot number"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Holding No.</Label>
                                    <Input
                                        type="text"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            holding_no: e.target.value
                                        }))}
                                        className="form-control-md"
                                        placeholder="Holding number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Area (Acres) <span className="text-danger">*</span></Label>
                                    <Input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            holding_area: e.target.value
                                        }))}
                                        className="form-control-md"
                                        placeholder="Area in acres"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Area Type <span className="text-danger">*</span></Label>
                                    <Input
                                        type="select"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            holding_type_id: e.target.value
                                        }))}
                                        className="form-control-sm"
                                        required
                                    >
                                        <option value="0">--Select Area Type--</option>
                                        <option value="1">Don</option>
                                        <option value="2">Baid</option>
                                        <option value="3">Tanr</option>
                                        <option value="4">Kanali</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Ownership</Label>
                                    <Input
                                        type="select"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            ownership: e.target.value
                                        }))}
                                        className="form-control-sm"
                                        required
                                    >
                                        <option value="">--Select Ownership--</option>
                                        <option value="1">Owner</option>
                                        <option value="2">Tenant</option>
                                        <option value="3">Sharecropper</option>
                                    </Input>
                                </FormGroup>
                            </Col>

                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Mouza No.</Label>
                                    <Input
                                        type="text"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            mouza_no: e.target.value
                                        }))}
                                        className="form-control-md"
                                        placeholder="Mouza number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">JL No.</Label>
                                    <Input
                                        type="text"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            jl_no: e.target.value
                                        }))}
                                        className="form-control-sm"
                                        placeholder="JL number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Khatiyan</Label>
                                    <Input
                                        type="text"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            khatiyan: e.target.value
                                        }))}
                                        className="form-control-md"
                                        placeholder="Khatiyan"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Latitude</Label>
                                    <Input
                                        type="text"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            latitude: e.target.value
                                        }))}
                                        className="form-control-md"
                                        placeholder="Latitude"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label className="fw-medium">Longitude</Label>
                                    <Input
                                        type="text"
                                        onChange={(e) => setAddLandData(prev => ({
                                            ...prev,
                                            longitude: e.target.value
                                        }))}
                                        className="form-control-md"
                                        placeholder="Longitude"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} className="">
                                <Button
                                    color="primary"
                                    size="sm"
                                    className="text-white align-items-center gap-2 w-100 mt-4"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <FaPlus className='me-1' />
                                    )}
                                    {loading ? 'Adding...' : 'Add Document'}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}

export default EditFarmer;